export default __webpack_public_path__ + "static/media/map1.a756622a.png";